import { useAuth0 } from "@auth0/auth0-react";
import { InputField } from "components";
import AutoCompleteField from "components/autoCompleteField";
import MyButton from "components/MyButton";
import SwitchComp from "components/switch";
import { TextareaField } from "components/TextareaField";
import { useFormik } from "formik";
import FinanceService from "Lib/API/Finance";
import { addProductSchema } from "pages/ValidationSchema";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import "../index.scss";

export const AddProduct = ({
  data,
  editClicked,
  refresh,
  setOpenModal,
  setRefresh,
  idObject,
  setGetSub,
  getSub,
  open,
}) => {
  const { ledgerAccounts } = useSelector((state) => state?.data);
  const [list, setList] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [ledgerValue, setLedgerValue] = useState(idObject?.ledgerId);
  const [subValue, setSubValue] = useState(idObject?.subId);
  const [checked, setChecked] = React.useState(false);
  const [value, setValue] = useState("");
  const initialValues = {
    checked: false,
    prod_name: data?.prod_name ? data?.prod_name : "",
    description: data?.description ? data?.description : "",
    year: data?.year ? data?.year : "",
    price: data?.price ? data?.price : "",
    prod_tax: data?.prod_tax ? data?.prod_tax : undefined,
    led_acc: ledgerValue,
    sub_cat: subValue,
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: addProductSchema,
    onSubmit: async (values) => {
      const token = await getAccessTokenSilently();
      const input = {
        led_acc: ledgerValue,
        sub_cat: subValue,
        prod_name: values?.prod_name,
        description: values?.description,
        year: values?.year,
        price: values?.price,
        prod_tax: values?.prod_tax,
      };

      if (data?._id) input.product_id = data?._id;

      if (editClicked)
        FinanceService.updateProduct(input, token)
          .then((res) => {
            if (res) {
              setOpenModal(false);
              setRefresh(!refresh);
            }
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
          });
      else
        FinanceService.addProduct(input, token)
          .then((res) => {
            if (res) {
              setOpenModal(false);
              setRefresh(!refresh);
            }
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
          });
    },
  });
  const style = {
    background: "#F3F6F9",
    height: "55px",
    border: "none",
  };
  React.useEffect(() => {
    if (data?.prod_tax) setChecked(true);
    formik.setFieldValue("checked", checked);
  }, [checked]);

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      await FinanceService.getSubcategoriesByLedgerAccountFiltered(
        "?active=true",
        ledgerValue,
        token
      )
        .then((res) => {
          if (res.length) {
            const subCat = [];
            res.map((item) => {
              subCat.push({
                value: item?._id,
                label: item?.sub_cat_name,
              });
              item.id = item._id;
              return item;
            });
            setList(subCat);
          } else {
            setList([]);
          }
        })
        .catch((err) => {
          setList([]);
          toastr.error("Error", err?.data?.message);

        });
    }
    fetchMyAPI();
  }, [getAccessTokenSilently, ledgerValue]);

  return (
    <dv className="add-ledger">
      <div className="form-title">{editClicked ? "Edit" : "Add"} Product</div>
      <div className="add-ledger-form pb-10">
        <form
          onSubmit={formik.handleSubmit}
          className="form fv-plugins-bootstrap fv-plugins-framework"
        >
          <div className="form-content w-100 col-sm-12">
            {!editClicked ? (
              <Row className="form-row sm-12 pb-10">
                <Col className="col-sm-5">
                  <AutoCompleteField
                    style={style}
                    classNamePrefix="react-select"
                    options={ledgerAccounts}
                    placeholder="Ledger Account"
                    onChange={(value) => {
                      setLedgerValue(value?.value);
                      setGetSub(!getSub);
                    }}
                    defaultValue={{
                      value: idObject?.ledgerId,
                      label: idObject?.ledgerName,
                    }}
                  />
                </Col>
                <Col className="col-sm-5">
                  <AutoCompleteField
                    style={style}
                    classNamePrefix="react-select"
                    options={list}
                    placeholder="Sub-Category"
                    onChange={(value) => {
                      setSubValue(value?.value);
                    }}
                    defaultValue={{
                      value: idObject?.subId,
                      label: idObject?.subName,
                    }}
                  />
                </Col>
              </Row>
            ) : (
              ""
            )}
            <Row className="form-row sm-12">
              <Col className="col-sm-5">
                <InputField
                  {...{
                    formik,
                    title: "Product Name",
                    name: "prod_name",
                    placeholder: "Discount",
                    checkValidation: true,
                  }}
                />
              </Col>
              <Col className="col-sm-5">
                <InputField
                  {...{
                    formik,
                    type: "number",
                    title: "Price",
                    name: "price",
                    placeholder: "$250",
                    checkValidation: true,
                  }}
                />
              </Col>
            </Row>
            <Row className="form-row sm-12">
              <Col className="col-sm-5">
                <TextareaField
                  rows="4"
                  {...{
                    formik,
                    title: "Description",
                    name: "description",
                    placeholder: "Write your description here",
                    checkValidation: true,
                  }}
                />
              </Col>
              <Col className="col-sm-5">
                <InputField
                  {...{
                    formik,
                    title: "Year",
                    name: "year",
                    placeholder: "2021",
                    checkValidation: true,
                  }}
                />
              </Col>
            </Row>
            {/* Tax Deductible */}
            <Row className="form-row col-sm-6 px-0 bottom">
              <p className="col-sm-6 tax-deductible-text">Tax Deductible</p>
              <div className="switch-comp col-sm-6 d-flex justify-content-end">
                <SwitchComp
                  checked={checked}
                  handleChange={(e) => setChecked(!checked)}
                />
              </div>
            </Row>
            <Row className="form-row col-sm-6 px-0 bottom">
              <Col
                className="col-sm-3"
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  alignSelf: "center",
                }}
              >
                Percentage
              </Col>
              <Col className="col-sm-6">
                <InputField
                  {...{
                    formik,
                    disabled: !checked,
                    type: "number",
                    name: "prod_tax",
                    placeholder: "10",
                    checkValidation: true,
                  }}
                />
              </Col>
            </Row>
          </div>
        </form>
      </div>
      <div className="add-button">
        <MyButton
          content={!editClicked ? "Add" : "Save"}
          style={{ width: "150px" }}
          onClick={() => {
            formik.handleSubmit();
          }}
        />
      </div>
    </dv>
  );
};
